import { render, staticRenderFns } from "./SelectStudent.vue?vue&type=template&id=5ac45442&scoped=true&"
import script from "./SelectStudent.vue?vue&type=script&lang=js&"
export * from "./SelectStudent.vue?vue&type=script&lang=js&"
import style0 from "./SelectStudent.vue?vue&type=style&index=0&id=5ac45442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac45442",
  null
  
)

export default component.exports